import config from "environment";
import { downloadRequest, getRequest, postRequest } from "./client";
import { TagExtended, RenameTagPayload, CreateTagInWorkspacePayload } from "effno-core";
import axios from "axios";

const { baseApi } = config;

export async function apiGetTag(id: string) : Promise<TagExtended | null> {
  const fetchURL = `${baseApi}/tags/${id}`;
  return await getRequest(fetchURL, "API/apiGetTag");
}

export async function apiGetTagsForWorkspace(workspaceId: string) : Promise<TagExtended[] | null> {
  const fetchURL = `${baseApi}/tags/workspace/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetTagsForWorkspace");
}

export async function apiCreateTagInWorkspace(payload: CreateTagInWorkspacePayload ) : Promise<TagExtended | null> {
  const fetchURL = `${baseApi}/tags/create`;
  return await postRequest(fetchURL, payload, "API/apiRenameTag");
}

export async function apiDeleteTag(tagId: string) : Promise<TagExtended | null> {
  const fetchURL = `${baseApi}/tags/delete/${tagId}`;
  return await getRequest(fetchURL, "API/apiDeleteTag");
}

export async function apiRenameTag(payload: RenameTagPayload) 
: Promise<TagExtended | null> {
  const fetchURL = `${baseApi}/tags/rename`;
  return await postRequest(fetchURL, payload, "API/apiRenameTag");
}
